import React, { useEffect, useState, useRef } from "react";
import { Button } from "@components/ui/button";
import {
  ChevronLeft,
  Delete,
  Download,
  Edit,
  Trash,
  Trash2,
} from "lucide-react";
import { supabaseClient } from "@/supabase/app";
import useAuth from "@hooks/useAuth";
import AddCampaign from "./addCampaign";
import {
  addPublishedMessage,
  CampaignMessages,
  isPublishedMessageExists,
  deleteCampaignMessage,
  getAllCampaignMessages,
  getAllPublishedCampaignMessages,
  getAllSavedMessages,
  saveTemplate,
  updateMessageById,
  editPublishedMessage,
} from "@redux/slices/campaign";
import { Campaign } from "@redux/slices/campaign";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill's styles
import LoadingScreen from "@components/LoadingScreen";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import * as Select from "@radix-ui/react-select";
// @ts-ignore
import html2pdf from "html2pdf.js";
import EditCampaignMessage from "./editCampaignMessage";
import { useNavigate } from "react-router";
import { countAtom } from "@/App";
import { useRecoilValue, useRecoilState } from "recoil";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RichTextEditor, { EditorValue, ToolbarConfig } from "react-rte";

interface Props {
  onChange?: (value: string) => void;
}

const MessageDetail: React.FC<Props> = ({ onChange }) => {
  const [messages, setMessages] = useState<CampaignMessages[] | undefined>();
  const [messagesR, setMessagesR] = useState<CampaignMessages[] | undefined>();

  const [Displaymessages, setDisplaymessages] = useState<
    CampaignMessages[] | undefined
  >();
  const [saved, setSaved] = useState<CampaignMessages[] | undefined>();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [closeModal, setCloseModal] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [closeEditModal, setCloseEditModal] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [selectedSequence, setSelectedSequence] = useState<number>(1);
  const [compaigns] = useRecoilValue(countAtom); // Accessing state with Recoil
  const quillRefs = useRef<{ [key: number]: any }>({});
  const [editorValues, setEditorValues] = useState<{ [key: number]: string }>(
    {}
  );
  const [editorValuesSave, setEditorValuesSave] = useState<{
    [key: number]: string;
  }>({});
  const [subjects, setSubjects] = useState<{ [key: number]: string }>({});
  const [subjectsSave, setSubjectsSave] = useState<{ [key: number]: string }>(
    {}
  );
  const [selectedValue, setSelectedValue] = useState<number>();
  const [disabled, setDisabled] = useState(false);
  const [publishDisabled, setPublishDisabled] = useState(true);
  const [id, setId] = useState(0);
  const [userSelectedSequence, setUserSelectedSequence] = useState<number>(1); // State for user-selected sequence

  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    getData();
  }, [showModal, showEditModal]);

  useEffect(() => {
    getData(); // Fetch data whenever the selected user sequence changes
  }, [userSelectedSequence]);

  useEffect(() => {
    getData(); // Fetch data whenever the selected user sequence changes
  }, [selectedSequence]);

  const [campaignName, setCampaignName] = useState("");
  const campaigns = useRecoilValue<Campaign[]>(countAtom);

  useEffect(() => {
    const campaignId = Number(window.location.pathname.split("/")[3]);
    const matchedCampaign = campaigns.find(
      (campaign) => campaign.id === campaignId
    );

    if (matchedCampaign) {
      setCampaignName(matchedCampaign.name);
    }
    console.log(campaigns);
  }, [campaigns]);


  const [saveTempmessages, setsaveTempmessages] = useState<
    CampaignMessages[] | undefined
  >();


  const [Tempmessages, setTempmessages] = useState<
  CampaignMessages[] | undefined
>();

const [messagesIds, setMessagesIds] = useState<number[] | undefined>(
  undefined
);

useEffect(() => {
    
  const fetchTemplateMesg = async () => {

    const published = await getAllCampaignMessages();

    const filteredPublished = published?.filter((i) => 
      i.id !== undefined && messagesIds?.includes(i.id)
    );

    setTempmessages(filteredPublished); 
  };

  fetchTemplateMesg(); 
}, [campaigns]); 


  useEffect(() => {
    
    const fetchAndSetSavedTemplates = async () => {
      const published = await getAllPublishedCampaignMessages();
      console.log(published)
      console.log("I am1")
      // Filter published messages based on messagesIds, ensuring ids are numbers
      const filteredPublished = published?.filter((i) => 
        i.message_id !== undefined && messagesIds?.includes(i.message_id) // Check if id is not undefined
      );

      setsaveTempmessages(filteredPublished); // No need for 'await' here
      console.log(filteredPublished)
      console.log("I am")
    };

   
    fetchAndSetSavedTemplates(); // Call the function to fetch and set data
  }, [campaigns,messagesIds]); 



  const getData = async () => {

    console.log("I am in get data")
    setLoading(true);
    const published = await getAllPublishedCampaignMessages();

    const filteredPublished = published
        ?.filter(
            (i) => i.campaign_id === Number(window.location.pathname.split("/")[3])
        )
        .filter((i) => user?.role === "admin" || i.user_id === user?.id); // Admin sees all messages


    if (filteredPublished && filteredPublished?.length > 0) {
      setDisabled(true);
      // setPublishDisabled(true)
    }

    const data: CampaignMessages[] | null = await getAllCampaignMessages();
    const savedData: CampaignMessages[] | null = await getAllSavedMessages();
    setDisplaymessages(filteredPublished);

    if (!data) {
      return savedData;
    }

    if (!savedData) {
      return data;
    }
    const savedMessagesMap = new Map<string, CampaignMessages>();

    savedData.forEach((savedMessage) => {
      const key = `${savedMessage.campaign_id}_${savedMessage.user_id}_${savedMessage.message_id}`;
      savedMessagesMap.set(key, savedMessage);
    });

    const combinedMessages = data.map((campaignMessage) => {
      const key = `${campaignMessage.campaign_id}_${user?.id}_${campaignMessage.id}`;
      return savedMessagesMap.get(key) || campaignMessage;
    });
    const filteredData = data
    ?.filter(
        (i) => i.campaign_id === Number(window.location.pathname.split("/")[3])
    )
    .filter((msg) => {
        // Check if the user is an admin
        if (user?.role === "admin") {
            return msg.sequence_id === selectedSequence; // Use selectedSequence for admin
        } else {
            return msg.sequence_id === userSelectedSequence; // Use userSelectedSequence for non-admin
        }
    })
    .sort((a, b) => {
        const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
        const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
        return dateA - dateB;
    });

    const filteredData1 = combinedMessages
      ?.filter(
        (i) => i.campaign_id === Number(window.location.pathname.split("/")[3])
      )
      .sort((a, b) => {
        const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
        const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
        return dateA - dateB;
      });

    setMessages(filteredData ?? undefined);
    setMessagesR(filteredData ?? undefined);
    setSaved(filteredData1 ?? undefined);

    if (filteredData) {
      const initialValues = filteredData?.reduce((acc, message) => {
        if (message.id !== undefined) {
          acc[message.id] = message.message; // Store the HTML string directly
        }
        return acc;
      }, {} as { [key: number]: string });

      const initialValuesSaved = filteredData1?.reduce((acc, message) => {
        if (message.message_id !== undefined) {
          acc[message.message_id] = message.message; // Store the HTML string directly
        }
        return acc;
      }, {} as { [key: number]: string });

      const initialSubjects = filteredData.reduce((acc, message) => {
        if (message.id !== undefined) {
          acc[message.id] = message.subject;
        }
        return acc;
      }, {} as { [key: number]: string });

      const initialSubjectsSaved = filteredData1.reduce((acc, message) => {
        if (message.message_id !== undefined) {
          acc[message.message_id] = message.subject;
        }
        return acc;
      }, {} as { [key: number]: string });


      setEditorValues(initialValues);
      setSubjects(initialSubjects);
      setEditorValuesSave(initialValuesSaved);
      setSubjectsSave(initialSubjectsSaved);
      setLoading(false);
    }
  };

  const handleChangeMessage = (id: number, newValue: string) => {
    setEditorValuesSave((prevValues) => ({
        ...prevValues,
        [id]: newValue,
    }));

    const updatedMessages = messages?.map((msg) =>
        msg.id === id ? { ...msg, message: newValue } : msg
    );
    setMessages(updatedMessages);

    if (onChange) {
        onChange(newValue);
    }
};

async function checkMessage(messageId: number) {
  const exists = await isPublishedMessageExists(messageId);

  return exists;
}

const handleTextChange = async (id: number) => {

  console.log("I am in textChange")

    const exists = await checkMessage(id);
    const quillInstance = quillRefs.current[id]?.getEditor();

  if (quillInstance) {
    const range = quillInstance.getSelection(); // Get the current selection
    if (range) {
      const text = quillInstance.getText(range.index - 1, 1); // Get the character before the cursor
      if (text !== " ") {
        // Check your condition
        if (exists) {
          // Apply formatting if condition is true
          
  console.log("I am in true")
          quillInstance.formatText(range.index - 1, 1, {
            bold: true,
            background: "yellow",
          });
        } else {
          
  console.log("I am in false")
          console.log("Condition not met, no formatting applied.");
        }
      }
    }
  }
};

  const handleSubjectChange = (id: number, newSubject: string) => {
    setSubjectsSave((prevSubjects) => ({
      ...prevSubjects,
      [id]: newSubject,
    }));

    const updatedMessages = messages?.map((msg) =>
      msg.id === id ? { ...msg, subject: newSubject } : msg
    );
    setMessages(updatedMessages);
  };

 

  useEffect(() => {
    if (messagesR && messagesR.length > 0) {
      const ids = messagesR
        .map((message) => message.id)
        .filter((id): id is number => id !== undefined);

      setMessagesIds(ids);
    }
  }, [messages]);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenEditModal = (id: any) => {
    setId(id);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };
  
  const addMessage = async (ids: number[]) => {
    setLoading(true);

    // Iterate through each id in the ids array
    for (const id of ids) {
      const messageData = {
        subject:
          subjectsSave[id] !== undefined ? subjectsSave[id] : subjects[id],
        message:
          editorValuesSave[id] !== undefined
            ? editorValuesSave[id] // Use the HTML string directly from ReactQuill
            : editorValues[id], // Fallback if there's no saved value
        campaign_id: Number(window.location.pathname.split("/")[3]),
        user_id: user?.id,
        sequence_id: selectedSequence, // Include the selected sequence ID here
      };

      const { data: existingPublishedMessage, error: checkError } =
        await supabaseClient
          .from("published_templates")
          .select("*")
          .eq("message_id", id)
          .single();

      if (checkError && checkError.code !== "PGRST116") {
        throw checkError;
      }

      const idsss = id;

      const messageData2 = {
        subject:
          subjectsSave[id] !== undefined ? subjectsSave[id] : subjects[id],
        message:
          editorValuesSave[id] !== undefined
            ? editorValuesSave[id] // Use the HTML string directly from ReactQuill
            : editorValues[id], // Fallback if there's no saved value
        campaign_id: Number(window.location.pathname.split("/")[3]),
        user_id: user?.id,
        sequence_id: selectedSequence, // Include the selected sequence ID here
      }

      console.log("ides are tis"+idsss)
    
      const message = String(
        editorValuesSave[idsss] !== undefined ? editorValuesSave[idsss] : editorValues[idsss]
      );
      await updateMessageById(idsss, message)

      if (existingPublishedMessage && idsss !== undefined) {
        await editPublishedMessage(idsss, messageData);
      } else {
        // If no published message exists, publish a new one
        if (idsss !== undefined) {
          await addPublishedMessage(idsss, messageData);
        }
      }
    }
    setSelectedValue(0);
    setDisabled(true);
    setPublishDisabled(true);
    setLoading(false);
    handleCloseModal();
    getData();
    setLoading(false); 
  };

  //

  const saveMessage = async (id: number) => {
    setLoading(true);
    const messageData = {
      subject: subjectsSave[id] ? subjectsSave[id] : subjects[id],
      message:
      editorValuesSave[id] !== undefined
        ? editorValuesSave[id] // Use the HTML string directly
        : editorValues[id], // Fallback if there's no saved value
      campaign_id: Number(window.location.pathname.split("/")[3]),
      user_id: user?.id,
      message_id: id,
      sequence_id: selectedSequence,
    };

    await saveTemplate(messageData);
    setSelectedValue(0);
    // setDisabled(true);
    // setPublishDisabled(true)
    await getData();
    setLoading(false);
    handleCloseModal();
  };

  const handleChange = (value: string) => {
    setSelectedValue(Number(value));
    // setPublishDisabled(false)
  };

  const downloadTemplate = () => {
    if (!selectedValue || !messagesR) return;

    const selectedMessage = messagesR.find((msg) => msg.id === selectedValue);
    if (!selectedMessage) return;

    const emailTemplate = `
      <div style="font-family: Arial, sans-serif; padding: 20px; background-color: #f4f4f4; max-width: 600px; margin: 0 auto;">
        <div style="background-color: #1CB5AF; color:white; font-size:16px;font-weight:500;  text-align: center; padding: 10px; padding-bottom:24px;">
          <h1>${selectedMessage.subject}</h1>
        </div>
        <div style="padding: 20px; background-color: #fff; border: 1px solid #ddd; ">
          <div style="font-size: 16px; line-height: 1.6; color: #333;">
            ${selectedMessage.message}
          </div>
        </div>
        <div style="text-align: center; margin-top: 30px; font-size: 14px; color: #888;">
          &copy; 2024 Your Company. All rights reserved.
        </div>
      </div>
    `;

    const tempElement = document.createElement("div");
    tempElement.innerHTML = emailTemplate;

    html2pdf()
      .from(tempElement)
      .set({
        margin: 1,
        filename: `${selectedMessage.subject}.pdf`,
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      })
      .save();
  };

  const handleDelete = async (id: number) => {
    setLoading(true);
    await deleteCampaignMessage(id);
    await getData();
    setLoading(false);
  };

  const toolbarConfig: ToolbarConfig = {
    display: [
      "INLINE_STYLE_BUTTONS",
      "BLOCK_TYPE_BUTTONS",
      "LINK_BUTTONS",
      "HISTORY_BUTTONS",
    ], // These are valid 'GroupName' values

    INLINE_STYLE_BUTTONS: [
      { label: "Bold", style: "BOLD", className: "custom-bold-button" },
      { label: "Italic", style: "ITALIC", className: "custom-italic-button" },
      {
        label: "Underline",
        style: "UNDERLINE",
        className: "custom-underline-button",
      },
    ],
    BLOCK_TYPE_BUTTONS: [
      {
        label: "UL",
        style: "unordered-list-item",
        className: "custom-ul-button",
      },
      {
        label: "OL",
        style: "ordered-list-item",
        className: "custom-ol-button",
      },
      {
        label: "Blockquote",
        style: "blockquote",
        className: "custom-blockquote-button",
      },
    ],
    BLOCK_ALIGNMENT_BUTTONS: [], // Add empty array for unused block alignment buttons
    BLOCK_TYPE_DROPDOWN: [], // Add empty array for unused block type dropdown
  };

  const handleOpenModalWithSequence = () => {
    setShowModal(true);
    // Pass the selected sequence to the AddCampaign component
  };

  // Define custom toolbar options
  const toolbarOptions = [
    ['bold'], // Bold and Italic buttons
    ['italic'],
    
  ];

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <div>{campaignName}</div>
          <div className="md:flex justify-between items-center mt-4">
            {/* Sequence Selector for Non-Admin Users */}
            {user?.role !== "admin" && (
              <div className="md:me-2 md:w-72">
                <Select.Root
                  value={String(userSelectedSequence)}
                  onValueChange={(value) => setUserSelectedSequence(Number(value))} // Update user-selected sequence
                >
                  <SelectTrigger
                    className="SelectTrigger bg-white border-none"
                    aria-label="Select User Sequence"
                  >
                    <SelectValue placeholder="Select User Sequence" />
                  </SelectTrigger>
                  <SelectContent className="SelectContent">
                    <SelectItem value="1">Sequence A</SelectItem>
                    <SelectItem value="2">Sequence B</SelectItem>
                  </SelectContent>
                </Select.Root>
              </div>
            )}
            {user?.role === "admin" && (
              <h2 className="text-gray font-bold flex items-center sm:text-[22px] text-lg capitalize mb-4">
                <ChevronLeft
                  size={22}
                  className="me-3 cursor-pointer"
                  onClick={() => navigate(-1)}
                />
                Email Templates
              </h2>
            )}
            <div className="md:me-2 md:w-72">
             
            </div>
            <div className="flex">
            {user?.role !== "admin" && (
                <Button
                  variant="secondary"
                  className="bg-white me-3"
                  onClick={getData}
                  // disabled={disabled}
                >
                
                  Reload
                </Button>
              )}
              {user?.role !== "admin" && (
                <Button
                  variant="secondary"
                  className="bg-white me-3"
                  onClick={downloadTemplate}
                  disabled={disabled}
                >
                  <Download size={18} className="me-2" />
                  Download
                </Button>
              )}
              {user?.role !== "admin" && (
                <Button className="bg-[#1CB5AF]" onClick={() => addMessage(messagesIds ?? [])}>
                  Publish
                </Button>
              )}
              {user?.role === "admin" && (
               <>
               <div className="md:me-2 md:w-72">
                 <Select.Root
                   value={String(selectedSequence)}
                   onValueChange={(value) =>
                     setSelectedSequence(Number(value))
                   }
                 >
                   <SelectTrigger
                     className="SelectTrigger bg-white border-none"
                     aria-label="Select Sequence"
                   >
                     <SelectValue placeholder="Select Sequence" />
                   </SelectTrigger>
                   <SelectContent className="SelectContent">
                     <SelectItem value="1">Sequence A</SelectItem>
                     <SelectItem value="2">Sequence B</SelectItem>
                   </SelectContent>
                 </Select.Root>
               </div>
               <Button onClick={handleOpenModalWithSequence}>Add New Message</Button>
             </>
              )}
            </div>
          </div>

          {user?.role !== "admin"
            ? messages?.map((val, index) => {
                const displayMessage = Displaymessages?.find(
                  (msg) => msg.message_id === val.id
                );

                const messageToDisplay =
                  saveTempmessages?.find((msg) => msg.message_id === val.id) || displayMessage;

                return (
                  <div key={val.id}>
                    <div className="flex gap-4 mt-5">
                      <div className="w-1/2 text-zinc-500">
                        <h4 className="text-xl font-bold flex items-center">
                          {index === 0 ? "First Message" : `Follow Up ${index}`}
                        </h4>
                        <h6 className="text-gray px-3 py-1 bg-white rounded-sm text-sm mt-4">
                          {messageToDisplay?.subject || "Message not published yet"}
                        </h6>
                        <p
                          className="px-3 pt-4 pb-5 bg-white rounded-sm text-sm mt-2"
                          dangerouslySetInnerHTML={{
                            __html: messageToDisplay?.message || "Message not published yet",
                          }}
                        ></p>
                      </div>
                      <div className="w-1/2">
                        <h4 className="text-xl font-bold flex items-center">
                          {index === 0 ? "First Message" : `Follow Up ${index}`}
                        </h4>
                        <input
                          className="px-3 py-1 bg-white rounded-sm text-sm my-4 w-full outline-none"
                          value={
                            subjectsSave[val.id!]
                              ? subjectsSave[val.id!]
                              : subjects[val.id!] || "Message not published yet"
                          }
                          onChange={(e) =>
                            handleSubjectChange(val.id!, e.target.value)
                          }
                        />
                        <ReactQuill
                          ref={(el) => (quillRefs.current[val.id!] = el)} // Store the editor instance in ref
                          value={editorValuesSave[val.id!] || editorValues[val.id!] || ""}
                          onChange={(newValue) => {
                            handleChangeMessage(val.id!, newValue);
                            handleTextChange(val.id!); // Call to apply formatting
                          }} // Use onChange to handle text changes
                          theme="snow"
                          modules={{
                            toolbar: toolbarOptions // Use the custom toolbar
                          }}

                        />
                      </div>
                    </div>
                    <div className="flex justify-end mt-4 ">
                      <Button className="bg-[#1CB5AF]" onClick={() => saveMessage(val?.id || 0)}>
                        Save
                      </Button>
                    </div>
                  </div>
                );
              })
            : (
              <>

                {messages
                  ?.filter((val) => val.sequence_id === selectedSequence) // Filter messages based on selected sequence
                  .map((val, index) => (
                    <div className="w-1/2" key={val.id}>
                      <div className="flex justify-between mt-4">
                        <h4 className="text-xl font-bold flex items-center">
                          {index === 0 ? "First Message" : `Follow Up ${index}`}
                        </h4>
                        <div className="flex items-center">
                          <Edit
                            className="me-4 text-lime-500 cursor-pointer"
                            onClick={() => handleOpenEditModal(val.id)}
                          />
                          <Trash2
                            className="text-red-600 cursor-pointer"
                            onClick={() => handleDelete(val.id || 0)}
                          />
                        </div>
                      </div>
                      <h6 className="px-3 py-1 bg-white rounded-sm text-sm mt-4">
                        {val.subject}
                      </h6>
                      <p
                        className="px-3 pt-4 pb-5 bg-white rounded-sm text-sm mt-2"
                        dangerouslySetInnerHTML={{
                          __html: val.message,
                        }}
                      ></p>
                    </div>
                  ))}
              </>
            )}

          {/* Add new message modal */}
          {showModal && (
            <AddCampaign
              closeModal={closeModal}
              setCloseModal={setCloseModal}
              showModal={showModal}
              handleCloseModal={handleCloseModal}
              id={Number(window.location.pathname.split("/")[3])}
              sequenceId={selectedSequence} // Pass the selected sequence here
            />
          )}
          {showEditModal && (
            <EditCampaignMessage
              closeModal={closeEditModal}
              setCloseModal={setCloseEditModal}
              showModal={showEditModal}
              handleCloseModal={handleCloseEditModal}
              id={id}
            />
          )}
        </div>
      )}
    </>
  );
};

export default MessageDetail;